export var changeLanguage = {
  data () {
    return {
      lang: 'en'
    }
  },

  methods: {
    setLanguage (lang) {
      this.lang = lang
    }
  }
}
